export enum PopupTypes {
  LoginOption,
  Form,
  Success,
}
